"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.runWithRetry = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const error_1 = require("../../error");
const globalVars_1 = require("../../common/globalVars");
async function runWithRetry(run, retryCondition, maxRetry = 3) {
    var _a;
    let lastResult = (0, teamsfx_api_1.err)(new teamsfx_api_1.SystemError("RetryMiddleware", "UninitializedResult", "runWithRetry did not execute the run function."));
    for (let i = 0; i < maxRetry; i++) {
        try {
            lastResult = await run();
            if (!retryCondition(lastResult, i + 1)) {
                return lastResult;
            }
        }
        catch (e) {
            const error = (0, error_1.assembleError)(e);
            if (!retryCondition((0, teamsfx_api_1.err)(error), i + 1)) {
                throw e;
            }
        }
        (_a = globalVars_1.TOOLS === null || globalVars_1.TOOLS === void 0 ? void 0 : globalVars_1.TOOLS.logProvider) === null || _a === void 0 ? void 0 : _a.info(`Retrying operation ... (${i + 1}/${maxRetry})`);
    }
    return lastResult;
}
exports.runWithRetry = runWithRetry;
//# sourceMappingURL=retry.js.map